import { jsx as _jsx } from "react/jsx-runtime";
import { InputStructureStandAlone } from './inputStructureStandAlone';
/**
 * @description
 * InputStructure component to structure inputs
 * @param {IInputStructure} props
 * @returns {JSX.Element}
 */
export const InputStructure = (props) => {
    return _jsx(InputStructureStandAlone, { ...props });
};
//# sourceMappingURL=inputStructure.js.map